import { useCallback, useEffect, useSyncExternalStore } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { THEME_ENUM } from '@/constants/theme.constant'
import { setMode } from '@/store/theme/themeSlice'
import { writeModePreference } from '@/store/theme/modePreference'

const SYSTEM_DARK = '(prefers-color-scheme: dark)'

const subscribeSystemMode = callback => {
    const query = window.matchMedia(SYSTEM_DARK)

    query.addEventListener('change', callback)

    return () => query.removeEventListener('change', callback)
}

const getSystemMode = () => window.matchMedia(SYSTEM_DARK).matches

function useDarkMode() {

    const mode = useSelector((state) => state.theme.mode)
    const { MODE_DARK, MODE_LIGHT, MODE_AUTO } = THEME_ENUM

    const prefersDark = useSyncExternalStore(subscribeSystemMode, getSystemMode)

    const isEnabled = mode === MODE_AUTO ? prefersDark : mode === MODE_DARK

    const dispatch = useDispatch()
    const onModeChange = useCallback(next => {
        writeModePreference(next)
        dispatch(setMode(next))
    }, [dispatch])

    useEffect(() => {
        const root = window.document.documentElement

        root.classList.remove(isEnabled ? MODE_LIGHT : MODE_DARK)
        root.classList.add(isEnabled ? MODE_DARK : MODE_LIGHT)
    }, [isEnabled])

    return [isEnabled, onModeChange, mode]
}

export default useDarkMode
